<template>
  <div>
    <BaseAvatar
      :initials="user?.initials ?? '##'"
      :status-color="state_color"
      :blink-icon-enabled="blinkIconEnabled"
      :blink-icon="blinkIcon"
      :hide-status="hideStatus"
      :ring-color="ringColor"
      :border-color="borderColorComputed"
      :shadow-color="shadowColor"
      :size="size"
      :img-url="user?.avatar_square_mini_url ?? null"
      :flat="flat"
      :second-icon="secondIconComputed"
      :second-icon-color="secondIconColorComputed"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'
import BaseAvatar from '@c/Avatar/BaseAvatar.vue'

export default {
  name: 'UserAvatar',
  components: { BaseAvatar },
  props: {
    userId: {
      type: String,
      required: true
    },
    role: {
      type: String,
      required: false,
      default: null
    },
    hideStatus: {
      type: Boolean,
      required: false,
      default: false
    },
    blinkIconEnabled: {
      type: Boolean,
      required: false,
      default: false
    },
    blinkIcon: {
      type: Array,
      required: false,
      default: () => ['fal', 'times']
    },
    ringColor: {
      type: String,
      required: false,
      default: null
    },
    shadowColor: {
      type: String,
      required: false,
      default: null
    },
    disponibility: {
      type: String,
      required: false,
      default: null
    },
    size: {
      type: String,
      required: false,
      default: 'medium',
      validator: (value) =>
        ['extra-small', 'small', 'medium', 'large', 'extra-large'].indexOf(
          value
        ) !== -1
    },
    flat: {
      type: Boolean,
      required: false,
      default: false
    },
    secondIcon: {
      type: [Array, String],
      required: false,
      default: null
    },
    secondIconColor: {
      type: String,
      required: false,
      default: null
    }
  },
  computed: {
    ...mapGetters({
      getUser: 'metadata/getAllUserMetadata'
    }),
    user() {
      return this.getUser(this.userId)
    },
    isBirthdayToday() {
      if (!this.user?.birth_date) {
        return false
      }
      return moment(this.user.birth_date).format('MM-DD') === moment().format('MM-DD')
    },
    secondIconComputed() {
      if (this.secondIcon) {
        return this.secondIcon
      }
      return this.isBirthdayToday ? 'cake-candles' : null
    },
    secondIconColorComputed() {
      if (this.secondIcon) {
        return this.secondIconColor
      }
      return this.isBirthdayToday ? 'text-pink-500' : null
    },
    borderColorComputed() {
      if (this.disponibility) {
        switch (this.disponibility) {
          case 'pending':
            return 'border-yellow-400'
          case 'confirmed':
            return 'border-green-500'
          case 'refused':
            return 'border-red-500'
        }
      }
      return 'border-white'
    },
    state_color() {
      if (!this.user) {
        return 'bg-red-700 text-white'
      }
      if (!this.user.online) {
        return 'bg-red-700 text-white'
      }
      switch (this.user.status) {
        case 'available':
          return 'bg-green-400 text-slate-800'
        case 'unavailable':
        case 'busy':
          return 'bg-yellow-500 text-slate-800'
        case 'offline':
          return 'bg-red-700 text-white'
        default:
          return 'bg-gray-300  text-slate-800'
      }
    }
  }
}
</script>
